// extracted by mini-css-extract-plugin
export var header = "_9h-0";